// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2u9ak","name":"styles_name__U6SpS","phone":"styles_phone__1Loz0"};